import axios from "axios";
import { SERVICE_URL } from "@/config";

// Create axios instance
export const apiClient = axios.create({
  baseURL: SERVICE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
// apiClient.interceptors.request.use(
//   (config) => {
//     // const accessToken = authTokensRef.current.accessToken;
//     // if (accessToken) {
//     //   config.headers.Authorization = `Bearer ${accessToken}`;
//     // }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// Response interceptor to handle token refresh
// apiClient.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     // Only retry on 401 and if we haven't already retried
//     // Don't retry session requests to prevent loops
//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       !originalRequest._isRefreshRequest &&
//       !originalRequest._isSessionRequest
//     ) {
//       originalRequest._retry = true;

//       // const refreshToken = authTokensRef.current.refreshToken;
//       // if (refreshToken) {
//       //   try {
//       //     // Use the token refresh manager to handle the refresh
//       //     // This prevents race conditions when multiple requests fail with 401
//       //     const tokens = await tokenRefreshManager.refreshToken(
//       //       refreshToken,
//       //       (newAccessToken, newRefreshToken, expiresIn) => {
//       //         // This callback is called when refresh succeeds
//       //         // Update the ref with new tokens and calculate new expiry
//       //         if(!expiresIn) {
//       //           console.warn("THE EXPIRES IN IS NOT PRESENT")
//       //         }
//       //         const expiresAt = Date.now() + ((expiresIn || 300) * 1000);
//       //         authTokensRef.current = {
//       //           accessToken: newAccessToken,
//       //           refreshToken: newRefreshToken,
//       //           expiresAt
//       //         };

//       //         // Also update localStorage for persistence
//       //         if (typeof window !== "undefined") {
//       //           localStorage.setItem("spicenet-access-token", newAccessToken);
//       //           localStorage.setItem("spicenet-refresh-token", newRefreshToken);
//       //           localStorage.setItem("spicenet-token-expiry", expiresAt.toString());
//       //         }
//       //       }
//       //     );

//       //     // Retry the original request with the new token
//       //     originalRequest.headers.Authorization = `Bearer ${tokens.accessToken}`;
//       //     return apiClient(originalRequest);
//       //   } catch (refreshError: any) {
//       //     console.error('[Axios Interceptor] Token refresh failed:', refreshError.response?.status);

//       //     // If refresh token is invalid (401), logout the user
//       //     if (refreshError.response?.status === 401) {
//       //       console.log('[Axios Interceptor] Refresh token invalid, logging out user');
//       //       // Clear tokens and redirect to home
//       //       authTokensRef.current = { accessToken: null, refreshToken: null, expiresAt: null };
//       //       if (typeof window !== "undefined") {
//       //         // Clear localStorage
//       //         localStorage.removeItem("spicenet-access-token");
//       //         localStorage.removeItem("spicenet-refresh-token");
//       //         localStorage.removeItem("spicenet-token-expiry");
//       //         // Clear React Query cache
//       //         window.location.href = "/";
//       //       }
//       //     }
//       //     return Promise.reject(refreshError);
//       //   }
//       // }
//     }

//     return Promise.reject(error);
//   }
// );
